import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { IInstrumentTemplateSummary } from '@brushfire/types'
import { TemplateTile } from './TemplateTile'

const CATEGORY_TITLE = '#061940'

type Props = Readonly<{
  label: string
  templates: IInstrumentTemplateSummary[]
  selectedTemplateId?: string | null
  interactive?: boolean
  onOpenTemplate?: (template: IInstrumentTemplateSummary) => void
  tileVariant?: 'sensemaker' | 'platformAdmin'
  onRequestHide?: (template: IInstrumentTemplateSummary) => void
  onRequestUnhide?: (template: IInstrumentTemplateSummary) => void
}>

export function TemplateCategorySection({
  label,
  templates,
  selectedTemplateId = null,
  interactive = true,
  onOpenTemplate,
  tileVariant = 'sensemaker',
  onRequestHide,
  onRequestUnhide,
}: Props) {
  if (templates.length === 0) return null

  return (
    <Box component="section" data-testid={`instrument-template-category-${label}`} sx={{ mb: 3 }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '24px',
          lineHeight: '31.2px',
          color: CATEGORY_TITLE,
          mb: 3,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, minmax(0, 1fr))',
          },
          gap: '24px',
        }}
      >
        {templates.map((template) => (
          <TemplateTile
            key={template.id}
            template={template}
            selected={selectedTemplateId === template.id}
            interactive={interactive}
            tileVariant={tileVariant}
            onRequestHide={onRequestHide}
            onRequestUnhide={onRequestUnhide}
            onOpen={
              interactive && onOpenTemplate ? () => onOpenTemplate(template) : undefined
            }
          />
        ))}
      </Box>
    </Box>
  )
}
